import { Handle, Position } from 'reactflow';
import { Image } from 'react-bootstrap';
import './nodeStyles.css';
import removeNodes from "../../assets/icons/removeNodes.svg";
import { findNextNode } from '../../utilities/Nodes/getConnectedChildNodes';
import { handleRemoveSingleConnected } from '../../utilities/Nodes/commonFunctions';
import { useFlowDataContext } from '../../context/workbench/FlowDataContext';
import { memo } from 'react';
import { usePermission } from '../../hooks/usePermission';

const QAOptionNode = ({ data, id }: any) => {
    const flowDataContext = useFlowDataContext();
    const { canView, canEdit } = usePermission();

    const nextNode = findNextNode(id, flowDataContext?.edges, flowDataContext?.nodes);
    return (
        <div className="add-button-container">
            <div className={`add-button-node ${nextNode?.type === "questionNode" ? "qa-question" : "qa-question"}`}>
                <p className="mb-0 button-text">{nextNode?.type === "questionNode" ? "question" : "question"}</p>
                {
                    canView && canEdit && (

                        <Image src={nextNode?.type === "questionNode" ? removeNodes : removeNodes} alt="removeIcon" className="pe-2" onClick={() => handleRemoveSingleConnected(data, id)} />
                    )
                }
                <Handle type="target" position={Position.Left} className="handle" id="left-handle" />
                <Handle type="source" position={Position.Right} className="handle" id="right-handle" />
            </div>
        </div>
    );
};

export default memo(QAOptionNode);